export default __webpack_public_path__ + "static/media/company10.226dc396.png";